export default __webpack_public_path__ + "static/media/icon-status-unset.f52a857f.svg";